import { useLang } from '@/i18n';
import EfBanner from 'elem/ui/ef-banner';
import EfSpec from 'elem/ui/ef-spec';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionB');
    const { locale = 'us', pathname } = useRouter();
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);

    const imgAllA = {
        NA: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724577009174/2560_R3P_UPS.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724577009010/1024_R3P_UPS.jpg',
        },
        EU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725008053425/euPC1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725008052966/euH1.jpg',
        },
        UK: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725008092991/ukPC1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725008053568/ukH1.jpg',
        },
        AUR3UPS: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1737527542020/7.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1737708109747/7_M.jpg',
        },
        PH: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751091088679/D.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751091088494/D-m.jpg',
        },
    };
    const imgLocaleA: any = {
        us: imgAllA.NA,
        ca: imgAllA.NA,
        br: imgAllA.NA,
        mx: imgAllA.NA,
        uk: imgAllA.UK,
        eu: imgAllA.EU,
        de: imgAllA.EU,
        fr: imgAllA.EU,
        it: imgAllA.EU,
        es: imgAllA.EU,
        ph: imgAllA.PH,
        au: pathname === '/river-3-portable-power-station' ? imgAllA.AUR3UPS : '',
    };
    const imgA = imgLocaleA[locale] || imgLocaleA['eu'];
    const configs = {
        className: pathname === '/river-3-portable-power-station' && locale === 'au' ? 'r3-ups' : '',
        pc: imgA.pc,
        h5: imgA.h5,
        label: t('label'),
        title: t('title'),
        desc: t('desc'),
        position: 'hoverL',
    };

    return (
        <div className={styles.TheComp}>
            <EfSpec className={IS_EU_SITES ? 'spec-x spec-eu' : 'spec-x'} />
            <EfBanner {...configs} />
        </div>
    );
}
